import OrdersTable from "./OrdersTable";

export default function InQueue() {
  return <OrdersTable type="in-queue" />;
}
